


































import { Vue, Component } from "vue-property-decorator";
import { namespace } from "vuex-class";

import UnterrichtDashboardCover from "@/views/UnterrichtDashboard/UnterrichtDashboardCover.vue";
import UnterrichtDashboardLink from "@/views/UnterrichtDashboard/UnterrichtDashboardLink.vue";
import UnterrichtDashboardWidget from "@/views/UnterrichtDashboard/UnterrichtDashboardWidget.vue";
import UnterrichtUserWidget from "@/views/UnterrichtDashboard/UnterrichtUserWidget.vue";

const UnterrichtDashboardModule = namespace("unterricht-dashboard");

@Component({
  components: {
    UnterrichtDashboardCover,
    UnterrichtDashboardWidget,
    UnterrichtDashboardLink,
    UnterrichtUserWidget,
  },
})
export default class UnterrichtDashboard extends Vue {
  public name = "UnterrichtDashboard";

  @UnterrichtDashboardModule.Action("findAllWidgets")
  public findWidgets: any;

  @UnterrichtDashboardModule.Action("findYtLink")
  public findYtLink: any;

  @UnterrichtDashboardModule.Getter("getDataList")
  public userWidgets: any;

  @UnterrichtDashboardModule.Getter("getYtLink")
  public youtubeLink: any;

  public get sortedUserWidgets(): any[] {
    return (this.userWidgets || []).slice().sort((a: any, b: any) => a.id - b.id);
  }

  public async mounted(): Promise<void> {
    await this.findWidgets();
    await this.findYtLink();
  }
}
